import { defineMessages } from "react-intl";

const messages = defineMessages({
  allResources: {
    id: "resources.sidebar.allResources",
    defaultMessage: "All Resources",
    description: "Sidebar all resources folder title",
  },
  delete: {
    id: "resources.sidebar.actions.delete.confirm",
    defaultMessage: "Delete",
    description: "Delete folder menu item title",
  },
  deleteConfirm: {
    id: "resources.sidebar.actions.delete.confirm.message",
    defaultMessage: "Are you sure you want to permanently delete this folder?",
    description: "Delete confirm title",
  },
  deleteForever: {
    id: "resources.sidebar.actions.delete.deleteForever",
    defaultMessage: "Delete Forever",
    description: "Delete forever button",
  },
  emptyTrash: {
    id: "resources.sidebar.actions.emptyTrash",
    defaultMessage: "Empty Trash",
    description: "Empty trash menu item",
  },
  emptyTrashMessage: {
    id: "resources.sidebar.actions.emptyTrash.message",
    defaultMessage: "Are you sure you want to permanently delete all files in trash? ",
    description: "Empty trash ppopcofirm message",
  },
  folderShareSuccess: {
    id: "resources.sidebar.actions.share.success",
    defaultMessage:
      "{folderName} shared with {count, plural, one {{userName}} other {{count} people}}",
    description: "Resource renamed success notification",
  },
  myFolders: {
    id: "resources.sidebar.myFolders",
    defaultMessage: "My Folders",
    description: "Sidebar my folders title",
  },
  rename: {
    id: "resources.sidebar.actions.rename",
    defaultMessage: "Rename",
    description: "Rename folder menu item title",
  },
  share: {
    id: "resources.sidebar.actions.share",
    defaultMessage: "Share",
    description: "Share folder menu item title",
  },
  sharedFolders: {
    id: "resources.sidebar.sharedFolders",
    defaultMessage: "Shared Folders",
    description: "Shared Folders title",
  },
  shareTitle: {
    id: "resources.sidebar.actions.share.modal.title",
    defaultMessage: "Share “{name}”",
    description: "Share folder menu item title",
  },
  storageAlmostFull: {
    id: "resources.sidebar.allResources.storageAlmostFull",
    defaultMessage: "You are nearing your storage limit.",
    description: "Storage almost full title",
  },
  storageFull: {
    id: "resources.sidebar.allResources.storageFull",
    defaultMessage: "You have reached your storage limit.",
    description: "Storage full title",
  },
  storageUsed: {
    id: "resources.sidebar.storage.info",
    defaultMessage: "<b>Org Usage:</b> {current} of {total} used",
    description: "Storage Used Info",
  },
  trash: {
    id: "resources.sidebar.trash",
    defaultMessage: "Trash",
    description: "Trash Folders title",
  },
  upgrade: {
    id: "resources.sidebar.storage.upgrade",
    defaultMessage: "Upgrade",
    description: "Storage upgrade button title",
  },
});

export default messages;
